import InitPage from "@/components/InitPage";
import React from "react";
import { Outlet } from "react-router-dom";

type WorkspaceBootstrapGateProps = {
  isInitializing: boolean;
};

const AppInitGate = ({ isInitializing }: WorkspaceBootstrapGateProps) => {
  return <>{isInitializing ? <InitPage /> : <Outlet />}</>;
};

export default AppInitGate;
